// extracted by mini-css-extract-plugin
export default {"application":"contentmain_application__y1P23"};